import { Activite } from './activite.model';
import { Site } from '../../../mnt/common/models/site.model';
import { DemandeIntervention } from '../../../mnt/common/models/demande-intervention.model';
import { Installation } from '../../../mnt/common/models/installation.model';

export interface OT extends Activite {
  affichageDetails: boolean;
  numero: string;
  typeOT: TypeOT;
  statut: StatutOT;
  libelle: string;
  description: string;
  demandeIntervention?: DemandeIntervention;
  installations: [Installation];
  instance: any;
  crIds: string[];
  site: Site;
  isMultiIntervenant: boolean;
  isControleReglementaire: boolean;
  isRdvClient: boolean;
  isTravailRestant: boolean;
  numeroGamme: string;
  has_echapetbelle: boolean;
  is_ot_sous_traitant: boolean;
}

export enum TypeOT {
  Conduite = 'conduite',
  Depannage = 'depannage',
  Correctif = 'correctif',
  Preventif = 'preventif',
  Permanence = 'permanence',
  Travaux = 'travaux',
  Gestion = 'gestion',
  Autres = 'autres',
}

export enum StatutOT {
  APreparer = 'a_preparer',
  Planifie = 'planifie',
  Attribue = 'attribue',
  AttenteMateriel = 'attente_materiel',
  SiteArret = 'site_arret',
  Demarre = 'demarre',
  ClosIntervenant = 'clos_intervenant',
  ClosValide = 'clos_valide',
  Historise = 'historise',
  Annule = 'annule',
}

export enum OrigineOT {
  GMAO = 'gmao',
  DAKTECH = 'daktech',
  DAKBOOK = 'dakbook',
  DAKBOARD = 'dakboard',
  ORION = 'orion',
  CSC = 'csc',
  DACRC = 'dacrc',
}
